export default "__VITE_ASSET__BQLubEMk__"